import React from 'react';
import PropTypes from 'prop-types';

FilterAutocompleteContainer.propTypes = {
    children: PropTypes.node,
};

function FilterAutocompleteContainer({children}) {
    return (
        <div style={{
            width: '50%',
            clear: 'both',
            display: 'grid',
            marginTop: '24px',
        }}>
            {children}
        </div>
    );
}

export default FilterAutocompleteContainer;
